import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Popup } from '@gem/popups';
import { Button, customScrollStyles, PopupFooter } from '@gem/ui-kit';

import { ChatAutoCleanupSettings } from 'APP/main/ChatView/ChatAutoCleanupSettings/ChatAutoCleanupSettings';

import {
  IChatAutoCleanupSettingsPopupProps,
  useChatAutoCleanupSettingsPopupPresenter,
} from './ChatAutoCleanupSettingsPopup.presenter';
import styles from './ChatAutoCleanupSettingsPopup.styles.m.css';

export const ChatAutoCleanupSettingsPopup: FC<IChatAutoCleanupSettingsPopupProps> = observer(
  (props) => {
    const presenter = useChatAutoCleanupSettingsPopupPresenter(props);
    const { t } = useTranslation();

    return (
      <Popup
        isOpened
        onClose={presenter.onClose}
        title={t('chat_auto_cleanup_title')}
      >
        <div className={classNames(styles.content, customScrollStyles.container)}>
          <div className={styles.tip}>{t('chat_auto_cleanup_web_description')}</div>
          <ChatAutoCleanupSettings
            groupId={presenter.groupId}
            value={presenter.currentTtlPeriodMs}
            onChange={presenter.setCurrentTtlPeriodMs}
          />
        </div>
        <PopupFooter className={styles.footer}>
          <Button
            isLoading={presenter.isSubmitting}
            isDisabled={presenter.isDisabled}
            theme="primary"
            onClick={presenter.onSubmit}
          >
            {t('common_save')}
          </Button>
        </PopupFooter>
      </Popup>
    );
  }
);
